
import { Component, Vue } from "vue-property-decorator";

import WidgetGetSponsorLicenceDialog from "@/modules/Compliance/Widgets/WidgetGetSponsorLicence/WidgetGetSponsorLicenceDialog.vue";

import ImageSponsorLicenceIcon from "@/modules/Compliance/Widgets/assets/icons/star.svg";

@Component({
  components: { WidgetGetSponsorLicenceDialog },
})
export default class WidgetGetSponsorLicence extends Vue {
  imageIcon = ImageSponsorLicenceIcon;

  popup = false;

  openPopup() {
    this.$emit("start");

    this.popup = true;
  }
}
